import { Button, Table } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import WarehouseService from "../../services/Warehouses/WarehouseService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/pro-duotone-svg-icons";
import { getRowClassName } from "../../helpers/common";

const WarehouseReceivingZonesTable = ({ handleModifying, handleReceivingZoneIdChange }) => {
  const { state: { warehouseId } } = useLocation();
  const { data: receivingZones, isLoading } = useQuery({
    queryKey: [warehouseId, "receivingZones"],
    queryFn: async () => await WarehouseService.getReceivingZonesByWarehouseId(warehouseId),
  });

  const handleEdit = (id) => {
    handleModifying(true);
    handleReceivingZoneIdChange(id);
  };

  const columns = [
    {
      title: "",
      dataIndex: "id",
      key: "id",
      width: "10%",
      render: (id) => (
        <Button onClick={() => handleEdit(id)} type="link" className="group">
          <FontAwesomeIcon
            icon={faPenToSquare}
            className="text-xl text-black block p-3 hover:text-cyan-500"
          />
        </Button>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Zone Type",
      dataIndex: "zoneType",
      key: "zoneType",
      render: (zoneType) => zoneType.name,
    },
    {
      title: "Docks",
      dataIndex: "warehouseDocks",
      key: "warehouseDocks",
      render: (docks) => docks.length > 0 ? docks.map(dock => dock.name).join(", ") : "N/A",
    },
  ];

  return (
    <Table dataSource={receivingZones}
           columns={columns}
           rowKey="id"
           loading={isLoading}
           size="small"
           scroll={{ y: 320, x: "max-content" }}
           rowClassName={getRowClassName}
           pagination={false}
    />
  );
};

export default WarehouseReceivingZonesTable;